/* eslint-disable react-hooks/exhaustive-deps */
import {FC, createContext, useContext, useEffect, useState} from 'react'
import {WithChildren, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {Link, useLocation} from 'react-router-dom'
import {useAuth} from '../../../../modules/auth'

export interface PageLink {
  title: string
  path: string
  isActive: boolean
  isSeparator?: boolean
}

export interface PageDataContextModel {
  pageTitle?: string
  setPageTitle: (_title: string) => void
  pageDescription?: string
  setPageDescription: (_description: string) => void
  pageBreadcrumbs?: Array<PageLink>
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => void
}

const PageDataContext = createContext<PageDataContextModel>({
  setPageTitle: (_title: string) => {},
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => {},
  setPageDescription: (_description: string) => {},
})

const PageDataProvider: FC<WithChildren> = ({children}) => {
  const [pageTitle, setPageTitle] = useState<string>('')
  const [pageDescription, setPageDescription] = useState<string>('')
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState<Array<PageLink>>([])

  const value: PageDataContextModel = {
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs,
  }
  return <PageDataContext.Provider value={value}>{children}</PageDataContext.Provider>
}

function usePageData() {
  return useContext(PageDataContext)
}

type Props = {
  description?: string
  breadcrumbs?: Array<PageLink>
  title?: string
  icon?: string
  desc?: string
}

const tabs = [
  {
    title: 'Profile',
    slug: 'profile',
    href: '/company-settings',
  },
  {
    title: 'Company',
    slug: 'company_info',
    href: '/company-settings/company_info',
  },
  {
    title: 'Framework',
    slug: 'framework',
    href: '/company-settings/framework',
  },
  {
    title: 'Security',
    slug: 'security',
    href: '/company-settings/security',
  },
  {
    title: 'Cookie Widget',
    slug: 'cookie-widget',
    href: '/company-settings/cookie-widget',
  },
  {
    title: 'SecureSlate AI',
    slug: 'advanced',
    href: '/company-settings/advanced',
  },
  {
    title: 'Users Permission',
    slug: 'users',
    href: '/company-settings/users',
  },
]

const SettingPageTitle: FC<Props & WithChildren> = ({
  children,
  description,
  breadcrumbs,
  title,
  icon,
  desc,
}) => {
  const {setPageTitle, setPageDescription, setPageBreadcrumbs} = usePageData()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(
    location.pathname.split('/').at(-1) === '' ? tabs[0].slug : location.pathname.split('/').at(-1)
  )
  const {currentUser} = useAuth()

  useEffect(() => {
    if (children) {
      setPageTitle(children.toString())
    }
    return () => {
      setPageTitle('')
    }
  }, [children])

  useEffect(() => {
    if (description) {
      setPageDescription(description)
    }
    return () => {
      setPageDescription('')
    }
  }, [description])

  useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs)
    }
    return () => {
      setPageBreadcrumbs([])
    }
  }, [breadcrumbs])

  useEffect(() => {
    let isFirstTab = true

    for (const tab of tabs) {
      if (location.pathname.includes(tab.slug)) {
        setActiveTab(tab.slug)
        isFirstTab = false
        break
      }
    }

    if (isFirstTab) setActiveTab(tabs[0].slug)
  }, [location.pathname])
  return (
    <>
      {icon ? (
        <div className={`card mb-5 mb-xl-8`}>
          <div className='card-header border-0 pt-5 mb-5'>
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-45px me-5 '>
                <img src={toAbsoluteUrl(`/media/logos/${icon}`)} alt='' />
              </div>
              <div className='d-flex justify-content-start flex-column'>
                <span className='card-label fw-bold fs-5'>{title}</span>
                <span className='fs-6 text-secondary-gray'>
                  {desc}
                </span>
              </div>
            </div>
          </div>
          {/*begin::Navs*/}
          <div className='px-10 '>
            {/* <div className='card-body'> */}
            <div className='d-flex  h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
                {/*begin::Nav item*/}
                <li className='nav-item'>
                  <Link
                    to={`/company-settings`}
                    style={{
                      color: '#6a7282',
                    }}
                    className={`nav-link fw-bold me-6 ${
                      activeTab === 'profile' ? 'text-active-primary active' : ''
                    }`}
                  >
                    Profile
                  </Link>
                </li>
                {/*end::Nav item*/}

                <li className='nav-item'>
                  <Link
                    to={'/company-settings/company_info'}
                    style={{
                      color: '#6a7282',
                    }}
                    className={`nav-link fw-bold me-6 ${
                      activeTab === 'company_info' ? 'text-active-primary active' : ''
                    }`}
                  >
                    Company
                  </Link>
                </li>

                {/*begin::Nav item*/}

                {currentUser?.account_type !== 'trust' && (
                  <li className='nav-item'>
                    <Link
                      to={'/company-settings/framework'}
                      style={{
                        color: '#6a7282',
                      }}
                      className={`nav-link fw-bold me-6 ${
                        activeTab === 'framework' ? 'text-active-primary active' : ''
                      }`}
                    >
                      Framework
                    </Link>
                  </li>
                )}

                {currentUser?.account_type !== 'trust' && (
                  <li className='nav-item'>
                    <Link
                      to={'/company-settings/security'}
                      style={{
                        color: '#6a7282',
                      }}
                      className={`nav-link fw-bold me-6 ${
                        activeTab === 'security' ? 'text-active-primary active' : ''
                      }`}
                    >
                      Security
                    </Link>
                  </li>
                )}

                {currentUser?.account_type !== 'trust' && (
                  <li className='nav-item'>
                    <Link
                      to={'/company-settings/cookie-widget'}
                      style={{
                        color: '#6a7282',
                      }}
                      className={`nav-link fw-bold me-6 ${
                        activeTab === 'cookie-widget' ? 'text-active-primary active' : ''
                      }`}
                    >
                      Cookie Widget
                    </Link>
                  </li>
                )}

                {currentUser?.account_type === 'internal' && (
                  <li className='nav-item'>
                    <Link
                      to={'/company-settings/advanced'}
                      style={{
                        color: '#6a7282',
                      }}
                      className={`nav-link fw-bold me-6 ${
                        activeTab === 'advanced' ? 'text-active-primary active' : ''
                      }`}
                    >
                      SecureSlate AI
                    </Link>
                  </li>
                )}

                {/* <li className='nav-item'>
                  <Link
                    to={'/company-settings/security'}
                    className={`nav-link me-6 ${
                      activeTab === 'security' ? 'text-active-primary active' : ''
                    }`}
                  >
                    Security
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    to={'/company-settings/language'}
                    className={`nav-link me-6 ${
                      activeTab === 'language' ? 'text-active-primary active' : ''
                    }`}
                  >
                    Language
                  </Link>
                </li> */}
                {/* <li className='nav-item'>
                  <Link
                    to={'/company-settings/roles'}
                    className={`nav-link me-6 ${
                      activeTab === 'roles' ? 'text-active-primary active' : ''
                    }`}
                  >
                    Roles
                  </Link>
                </li> */}
                {(currentUser?.role === 'Owner' || currentUser?.role === 'Admin') && currentUser?.account_type?.toLocaleLowerCase() !== 'trial' && currentUser?.account_type !== 'trust' && (
                    <li className='nav-item'>
                      <Link
                        to={'/company-settings/users'}
                        style={{
                          color: '#6a7282',
                        }}
                        className={`nav-link fw-bold me-6 ${
                          activeTab === 'users' ? 'text-active-primary active' : ''
                        }`}
                      >
                        Users Permission
                      </Link>
                    </li>
                  )}
                {/*end::Nav item*/}
              </ul>
            </div>
            {/*begin::Navs*/}
          </div>
          {/* </div> */}
          {/*begin::Navs*/}
        </div>
      ) : null}
    </>
  )
}

const PageDescription: FC<WithChildren> = ({children}) => {
  const {setPageDescription} = usePageData()
  useEffect(() => {
    if (children) {
      setPageDescription(children.toString())
    }
    return () => {
      setPageDescription('')
    }
  }, [children])
  return <></>
}

export {PageDescription, SettingPageTitle, PageDataProvider, usePageData}
